import React, {useState, useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import ReactModal from "react-modal";

import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import facilityIcon from "../../../../../resources/images/facility-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {LeftLabelTextInput} from "../../../../common/input/left-label-text-input/LeftLabelTextInput";
import {createPerson, retrieveAllPersons} from "../../../../../services/PersonService";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {createPersonDropdownDisplayValue, sortPersonList} from "../../../../../util/PersonUtil";

export const TopicAreaTwo = ({context, setContext, navigateTo, navigateBack, showToaster, setSpinnerText, toolTipsEnabled}) => {
    ReactModal.setAppElement('#root');

    const [allContactPersonList, setAllContactPersonList] = useState([]);
    const [availableContactPersonList, setAvailableContactPersonList] = useState([]);
    const [selectedContactPersonList, setSelectedContactPersonList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [organisation, setOrganisation] = useState(null);
    const [role, setRole] = useState(null);
    const [email, setEmail] = useState(null);

    useEffect(() => {
        if (!context.viewMode) {
            setContext((prevState) => ({
                ...prevState,
                breadcrumbs: {
                    ...prevState.breadcrumbs,
                    topicAreaBreadcrumb: {
                        text: context.topicAreaScreen.topicArea.topicArea,
                        type: "Topic Area",
                        screenKey: "topicAreaOne",
                    }
                },
            }));
        }

        const fetchData = async () => {
            setSpinnerText("Retrieving Contact Persons");
            const [data] = await retrieveAllPersons(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    const mappedContactPersons = data.personVOList.map((contact) => {
                        return {...contact, displayValue: createPersonDropdownDisplayValue(contact)}
                    });
                    sortPersonList(mappedContactPersons);
                    setAllContactPersonList(mappedContactPersons);
                }
            }
            setSpinnerText(null);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (context.topicAreaScreen) {
            if (context.topicAreaScreen.contactPersonList) {
                setSelectedContactPersonList([...context.topicAreaScreen.contactPersonList]);
                let filteredAvailableContactPersonList = allContactPersonList.filter((contactPerson) => {
                    return !selectedContactPersonList.find((selectedContactPerson) => {
                        return (selectedContactPerson.externalReference === contactPerson.externalReference && selectedContactPerson.displayValue === contactPerson.displayValue)
                    });
                });
                setAvailableContactPersonList([...filteredAvailableContactPersonList]);
            } else {
                setAvailableContactPersonList([...allContactPersonList]);
            }
        }
    }, [allContactPersonList, context]);

    const handleContactPersonChange = (selectedContactPerson) => {
        setSelectedContactPersonList((prevState) => ([...prevState, selectedContactPerson]));
        let copyOfAvailableContactPersonList = [...availableContactPersonList];
        let index = copyOfAvailableContactPersonList.indexOf(selectedContactPerson);
        copyOfAvailableContactPersonList.splice(index, 1);
        sortPersonList(copyOfAvailableContactPersonList);
        setAvailableContactPersonList(copyOfAvailableContactPersonList);
    }

    const handleContactPersonClick = (selectedContactPerson) => {
        let copyOfSelectedContactPersonList = [...selectedContactPersonList];
        let index = copyOfSelectedContactPersonList.indexOf(selectedContactPerson);
        copyOfSelectedContactPersonList.splice(index, 1);
        setSelectedContactPersonList(copyOfSelectedContactPersonList);
        const copyOfAvailableContactPersonList = [...availableContactPersonList];
        copyOfAvailableContactPersonList.push(selectedContactPerson);
        sortPersonList(copyOfAvailableContactPersonList);
        setAvailableContactPersonList([...copyOfAvailableContactPersonList]);
    }

    const openModal = () => {
        setShowModal(true)
    }

    const closeModal = () => {
        setShowModal(false);
        setFirstName(null);
        setLastName(null);
        setEmail(null);
        setOrganisation(null);
        setRole(null);
    }

    const handleCreatePersonClick = async () => {
        setSpinnerText("Creating Person");
        const personToBeSaved = {firstName, lastName, email, organisation, organisationRole: role, active: true};
        const [data, error] = await createPerson(context.username, personToBeSaved);
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                const savedPerson = data.savedPersonVO;
                handleContactPersonChange({
                    ...savedPerson,
                    displayValue: createPersonDropdownDisplayValue(savedPerson),
                });
                closeModal();
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    const handleNextClick = () => {
        setContext((prevState) => ({
            ...prevState,
            topicAreaScreen: {...prevState.topicAreaScreen, contactPersonList: selectedContactPersonList}
        }));
        navigateTo("topicAreaThree");
    }

    const selectedContactPersonListItems = selectedContactPersonList.map((selectedContactPerson) => {
        return (
            <div className="list-item-container" key={selectedContactPerson.externalReference}>
                <p className={context.editMode ? "list-item" : "disabled-list-item"}>{selectedContactPerson.displayValue}</p>
                <div className={context.editMode ? "list-item-delete-button" : "disabled-list-item-delete-button"}
                     onClick={context.editMode ? () => {handleContactPersonClick(selectedContactPerson)} : null}>
                    <FontAwesomeIcon className="list-item-delete-icon" icon={faTimes}/>
                </div>
            </div>
        );
    });

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={facilityIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.facilityScreen.locationBreadCrumbText}</p>
                </div>
                <div className="wizard-right-container">
                    <div className={"label-div-tooltip-o"}>
                        <label className="label">Contact Person(s):</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"ta2contact1"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Contact Person(s):"}/>}
                    </div>
                    {selectedContactPersonListItems}
                    <div className="input-container">
                        <Select options={availableContactPersonList}
                                getOptionLabel={(availableContactPerson) => availableContactPerson.displayValue}
                                getOptionValue={(availableContactPerson) => availableContactPerson.externalReference}
                                onChange={handleContactPersonChange}
                                isDisabled={!availableContactPersonList || !context.editMode}
                                value={null}
                                classNamePrefix="select"
                        />
                    </div>
                    <StandardButton text="Create Person" onClick={openModal} disabled={!context.editMode}/>
                    {context.viewMode &&
                    <CommentToolTip contextName={"Visit"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.topicAreaScreen.visitExternalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={selectedContactPersonList.length === 0} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>

            <ReactModal isOpen={showModal} className="modal-content" overlayClassName="modal-overlay">
                <p className="modal-title">Create Person</p>
                <LeftLabelTextInput labelText="First Name:" handleChange={({target}) => {
                    setFirstName(target.value)
                }}/>
                <LeftLabelTextInput labelText="Last Name:" handleChange={({target}) => {
                    setLastName(target.value)
                }}/>
                <LeftLabelTextInput labelText="Email:" handleChange={({target}) => {
                    setEmail(target.value)
                }}/>
                <LeftLabelTextInput labelText="Organisation:" handleChange={({target}) => {
                    setOrganisation(target.value)
                }}/>
                <LeftLabelTextInput labelText="Organisation Role:" handleChange={({target}) => {
                    setRole(target.value)
                }}/>
                <div className="modal-button-container">
                    <StandardButton text="Create Person" onClick={handleCreatePersonClick}
                                    disabled={!firstName || !lastName || !organisation || !role}/>
                    <StandardButton text="Cancel" onClick={closeModal}/>
                </div>
            </ReactModal>
        </div>
    );
}
